import React from 'react';

import { useAuthDataContext } from 'components/AuthDataProvider/AuthDataProvider';

import MyBrokeragePage from 'views/BrokerageAdmin/MyBrokeragePage';
import AdminDashboardPage from 'views/Dashboard/AdminDashboardPage';
import AgentHomePage from 'views/Dashboard/AgentHomePage';
import CampaignDashboardPage from 'views/Dashboard/CampaignDashboardPage';

const DashboardPageWrapper = () => {
  const { isAdmin, isBrokerageAdmin, isAnyAgent } = useAuthDataContext();

  if (isAdmin) {
    return <AdminDashboardPage />;
  }

  if (isBrokerageAdmin) {
    return <MyBrokeragePage />;
  }

  return isAnyAgent ? <AgentHomePage /> : <CampaignDashboardPage />;
};

export default DashboardPageWrapper;
